import styled from 'styled-components';
import { FontStyle } from '../../../shared/components/styles/FontStyle';
import { ColorConstants } from '../../../shared/constants/index';
import { WrapperTwoButtons } from '../../../shared/buttons';

export const Wrapper = styled.div`
    margin-bottom:5px;
`;

export const Title = styled.h1`
    ${FontStyle};
    font-size: 20px;
    font-weight: 700;
    margin: 0;
    line-height: normal;
    color: ${ColorConstants.white};
`;

export const Subtitle = styled.h3`
    ${FontStyle};
    font-size: 15px; 
    font-weight: 400;
    margin: 0;
    color: ${ColorConstants['regal-blue']};
`;

export const SubtitleWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const StyledWrapperTwoButtons = styled(WrapperTwoButtons)`
    margin-top: 40px;
`;
